export default __webpack_public_path__ + "static/media/MXConnect.5be3f4e2.svg";